import { useMemo } from 'react';

import { getAvailableMailingProducts, type MailingProduct, type MailingType } from '@/services/ws-post/src/main/resources/rest-api';
import { useSubscribe } from '@/js/libs/observable';
import { useRequest } from '@/js/libs/use-request';

import { getProductsForMailingType } from '../mailingProduct';

export const useAvailableMailingProducts = (mailingType: MailingType | undefined): { products: MailingProduct[]; pending: boolean } => {
  const availableMailingProductsRequest = useRequest({
    apiMethod: getAvailableMailingProducts,
  });

  const availableProducts = useSubscribe(availableMailingProductsRequest.data$, (response) => response?.data);
  const pending = useSubscribe(availableMailingProductsRequest.pending$);

  const products = useMemo(() => getProductsForMailingType(availableProducts, mailingType), [availableProducts, mailingType]);

  return { products, pending };
};
